"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.tableConfig = void 0;
var tableConfig = exports.tableConfig = [{
  label: '优惠券ID',
  prop: 'id'
}, {
  label: '优惠券名称',
  prop: 'name'
}, {
  label: '领券时间',
  prop: 'time'
}, {
  label: '券有效期',
  prop: 'validity'
}, {
  label: '优惠信息',
  prop: 'couponDiscount'
}, {
  label: '适用分销客户',
  prop: 'distributionCustomers'
}, {
  label: '领用规则',
  prop: 'limitType'
}, {
  label: '是否公开',
  prop: 'isPublic'
}, {
  label: '领用链接',
  prop: 'g',
  btnText: '复制链接'
}, {
  label: '优惠券返回链接',
  prop: 'redeemPageUrl',
  btnText: '复制链接'
}, {
  label: '参与商品',
  prop: 'applicableRangeType'
}, {
  label: '发放数量',
  prop: 'totalQuantity'
}];